import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';

import rootReducer from '../reducers/root.reducer';

import apiSaga from '../saga/api.saga';
import appSaga from '../saga/app.saga';
import pagesSaga from '../saga/pages.saga';

const saga = createSagaMiddleware();

export const history = createBrowserHistory();
export const mainStore = ({ initialState = {} } = {}) => {
	const store = createStore(
		rootReducer,
		initialState,
		composeWithDevTools(applyMiddleware(saga)),
	);

	saga.run(apiSaga);
	saga.run(appSaga);
	saga.run(pagesSaga);

	return store;
};
